<template>
  <v-row class="ma-0 pb-3 px-4 justify-space-between details-row">
    <span>{{ $t(label) }}</span>
    <slot :value="value">
      <span :class="{ 'text-h4': valueLarge }">{{ value }}</span>
    </slot>
  </v-row>
</template>

<script>
export default {
  name: 'OrderDetailRow',
  props: {
    label: {
      type: String,
      default: '',
    },
    value: {
      type: String | Number,
      default: '',
    },
    valueLarge: {
      type: Boolean,
      default: false,
    },
  },
}
</script>
<style lang="scss" scoped>
.details-row {
  & * {
    color: var(--v-colorBlack-base);
    font-size: 0.875rem;
    font-weight: 500;
  }
}
</style>
